import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path d="M5.5,6 L10.5,6 C12.442809,6 13.5,7.05719096 13.5,9 C13.5,10.942809 12.442809,12 10.5,12 L9,12 L9,11 L10.5,11 C11.8905243,11 12.5,10.3905243 12.5,9 C12.5,7.60947571 11.8905243,7 10.5,7 L5.5,7 L5.5,10 L2,6.5 L5.5,3 L5.5,6 Z"/>
  </svg>
);
